<template>
  <div class="joint-login">
    <main class="joint-login__card">
      <h1>授权登录</h1>

      <login-form
        v-if="!loggedIn"
        class="joint-login__form"
        submit-text="登录并授权"
        redirect-after-login=""
        @login-success="authorizeAfterLogin"
      />
      <div v-else class="joint-login__actions">
        <el-button
          class="joint-login__authorize"
          type="primary"
          :loading="loading"
          :disabled="loading || restartRequired"
          @click="authorize"
        >
          授权登录
        </el-button>
        <el-button
          class="joint-login__logout"
          type="text"
          :disabled="loading"
          @click="logout"
        >
          退出登录
        </el-button>
      </div>

      <footer class="joint-login__footer">
        <i class="el-icon-lock"></i>
        安全连接 · 授权信息加密传输
      </footer>
    </main>
  </div>
</template>

<script>
import { AuthorizationStatus } from "../warehouse_receipt/receiptEnums";
import LoginForm from "@/views/login/components/LoginForm";
import authorizationApi from "@/api/warehouseReceiptAuthorization";
import { getToken } from "@/utils/token";

export default {
  components: { LoginForm },
  data() {
    return {
      loggedIn: Boolean(getToken()),
      loading: false,
      restartRequired: false
    };
  },
  methods: {
    authorizeAfterLogin() {
      this.loggedIn = true;
    },
    async authorize() {
      this.loading = true;
      try {
        const result = await authorizationApi.authorize({
          sessionId: this.$route.query.session_id,
          callbackUrl: this.$route.query.callback_url
        });
        if (result.status === AuthorizationStatus.SUCCESS) {
          this.redirect(result.redirectUrl);
        } else {
          this.restartRequired =
            result.status === AuthorizationStatus.RESTART_REQUIRED;
          this.$message.error(result.message || "授权失败，请重试");
        }
      } catch (error) {
        this.$message.error("授权失败，请重试");
      } finally {
        this.loading = false;
      }
    },
    async logout() {
      await this.$store.dispatch("logOut");
      this.loggedIn = false;
      this.restartRequired = false;
    },
    redirect(url) {
      window.location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
.joint-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 48px 8vw;
  background: linear-gradient(
      90deg,
      rgba(4, 24, 58, 0.02),
      rgba(4, 24, 58, 0.25)
    ),
    url("../../static/img/rwa/joint-login-bg.jpg") center / cover no-repeat;

  &__card {
    width: 420px;
    box-sizing: border-box;
    padding: 42px 46px 30px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 24px 70px rgba(2, 21, 52, 0.34);
    backdrop-filter: blur(12px);
  }

  h1 {
    margin: 0 0 30px;
    color: #102a56;
    font-size: 28px;
    line-height: 1.4;
    font-weight: 600;
  }

  &__form {
    ::v-deep .el-form-item.form-item .el-input__inner {
      height: 44px;
      border: 1px solid rgba(22, 119, 255, 0.12);
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.68);
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
      }
    }

    ::v-deep .el-form-item.form-item .el-input__prefix {
      display: flex;
      align-items: center;

      img {
        margin: 0 16px;
      }
    }

    ::v-deep .vfCode-inner {
      flex-direction: row-reverse;
      gap: 12px;

      .el-input {
        min-width: 0;
      }

      .el-input__inner {
        padding: 0 14px;
      }

      > img {
        flex: 0 0 116px;
        width: 116px;
        height: 44px;
        box-sizing: border-box;
        object-fit: contain;
        border: 1px solid rgba(22, 119, 255, 0.12);
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.82);
        cursor: pointer;
      }
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-top: 4px;
  }

  &__authorize {
    width: 100%;
    height: 44px;
    margin-bottom: 10px;
    border: 0;
    border-radius: 7px;
    background: linear-gradient(90deg, #1677ff, #35a8ff);
    font-size: 16px;
    box-shadow: 0 8px 20px rgba(22, 119, 255, 0.24);
  }

  &__logout {
    margin-left: 0;
    border: 0;
    box-shadow: none;

    &::after {
      display: none;
    }
  }

  &__footer {
    margin-top: 22px;
    padding-top: 20px;
    border-top: 1px solid #edf1f7;
    color: #a0aec0;
    font-size: 12px;
    text-align: center;

    i {
      margin-right: 4px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .joint-login {
    justify-content: center;
    padding: 24px 18px;

    &__card {
      width: 100%;
      max-width: 420px;
      padding: 34px 28px 26px;
    }
  }
}
</style>
